import {SmartComponent} from "smart-component-js";
import FormUtils from "../common/FormUtils";

class FormComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        params = params || {};
        params.className = "FormComponent";
        super(element, parentComponent, params);

        this.form = $(element);
        this.prefixField = null;

        this.ipCountry = FormUtils.readFormIpCountry(this.form);
        this.idLanding = this.form.data('landingId');
        this.singleCourse = this.form.data('singleCourse');
        this.customCourses = this.form.data('customCourses');
        this.typologyCustom = this.form.data('typologyCustom');
        this.isEvent = this.form.data('isEvent');

        this.$urlBackField = this.form.find('[name="ret_url"].returnUrl');

        this.subareaData = {};

        this.init();
    }

    init() {
        $('[data-go-to-form]').click(() => {
            let top = this.form.parents('.form-wrp').offset().top - $('header').outerHeight();
            $('html, body').scrollTop(top);
        });
        this.form.on('change', 'select', (e) => {
            $(e.currentTarget).toggleClass('selected', $(e.currentTarget).val() != null)
        })
        if (this.form.find('#school').length > 0 && this.form.find('.schoolDependant').length > 0) {
            this.form.find('#school').change((e) => {
                let val = $(e.currentTarget).find('option:selected').attr('value').toLowerCase();
                FormUtils.updateSchoolDependantFields(val, this.form);
            });
        } else if (this.form.find('#campusSchoolParent').length > 0) {
            let val = this.form.find('#campusSchoolParent').val();
            FormUtils.updateSchoolDependantFields(val, this.form);
        }

        if (this.form.find("#school").length > 0 && this.form.find("#programme").length > 0) {
            this.form.find("#school").change((e) => {
                let $programme = this.form.find("#programme");
                FormUtils.resetSelect($programme);
                this.hideTime();

                let school = this.form.find("#school").val();
                if (!!school && school != 'null') {
                    FormUtils.showLoader();
                    this.programmeData = false;
                    FormUtils.loadProgramme(this.idLanding, this.customCourses, school).then((data) => {
                        let html = '';

                        for (let c in data) {
                            html += `<option value="${data[c].value}">${data[c].label}</option>`;

                            if (!!data[c].data) {
                                if (!this.programmeData) {
                                    this.programmeData = {};
                                }

                                this.programmeData[data[c].value] = data[c].data;
                            }
                        }
                        $programme.append(html);
                        this.form.find("#subarea-wrapper").toggle(!!this.programmeData);

                        FormUtils.hideLoader();
                    });
                }
            });

            const select = document.querySelector('#school');

            let validIndex = -1;
            let count = 0;

            for (let i = 0; i < select.options.length; i++) {
                const val = select.options[i].value;

                if (val && val !== 'null') {
                    count++;
                    validIndex = i;

                    if (count > 1) break;
                }
            }

            if (count === 1) {
                select.selectedIndex = validIndex;
                select.dispatchEvent(new Event('change', {bubbles: true}));
                select.classList.add('disabledSelect');
            }

            this.form.find("#programme").change((e) => {
                let $programme = this.form.find("#programme");
                let $subarea = this.form.find("#subarea");
                this.hideTime();

                FormUtils.resetSelect($subarea);

                if (!!$programme.val() && this.programmeData[$programme.val()]) {
                    let html = '';
                    for (let s in this.programmeData[$programme.val()]) {
                        let subarea = this.programmeData[$programme.val()][s];
                        html += `<option value="${subarea.value}">${subarea.label}</option>`;

                        if (subarea.data) {
                            this.subareaData[subarea.value] = subarea.data;
                        } else {
                            this.subareaData[subarea.value] = {};
                        }
                    }
                    $subarea.append(html);
                }
            });

            this.form.find("#subarea").change((e) => {
                let $time = this.form.find("#time");

                if ($time.length > 0) {
                    FormUtils.resetSelect($time);
                    let subarea = this.form.find("#subarea").val();

                    if (this.subareaData && subarea && this.subareaData[subarea]) {
                        let times = this.subareaData[subarea];
                        if (times && times.length > 0) {
                            let html = '';
                            for (let t in times) {
                                // data e' assente per i time senza evento (e per i timeslot middleware e' la lista location)
                                let data = times[t].data || {};
                                let typology = data.typology || '';
                                let typologyCustom = data.typologyCustom || '';
                                html += `<option value="${times[t].value}" data-typology="${typology}" data-typology-custom="${typologyCustom}">${times[t].label}</option>`;
                            }
                            $time.append(html);
                            this.form.find('#time-wrapper').show();
                        }
                    } else {
                        this.hideTime();
                    }
                }
            });

            this.form.find("#time").change((e) => {
                this.updateWebform();
            });
        }

        this.form.submit((ev) => {

            if (!this.form.find('[name="recaptchaToken"]').val()) {
                if (FormUtils.validateForm(ev, this.form)) {
                    FormUtils.scrollToError(this.form);
                } else {
                    ev.preventDefault();
                    FormUtils.doCaptcha(this.form, this.$urlBackField);
                }
            }

        });

        window.addEventListener("scroll", () => {
            this.manageScroll();
        }, false);

        this.manageScroll();

        FormUtils.addFormListeners(this.form);
    }

    updateWebform() {
        let selOption = this.form.find("#time option:selected");
        let typology = null;
        let custom = null;
        if (selOption.length > 0) {
            typology = selOption.data('typology');
            custom = selOption.data('typologyCustom');
        }

        if ('OPENDAY' == typology || 'VIRTUALOPENDAY' == typology) {
            this.form.find('.webformname').val('OpenDay');
        } else if (this.isEvent) {
            this.form.find('.webformname').val('GenericEvent');
        } else {
            this.form.find('.webformname').val('landingminimal');
        }
        if (!!custom) {
            this.form.find('.WEBFORMTYPE').val(custom);
        } else if ('VIRTUALOPENDAY' == typology) {
            this.form.find('.WEBFORMTYPE').val('Virtual_OD');
        } else if (!!this.typologyCustom) {
            this.form.find('.WEBFORMTYPE').val(this.typologyCustom);
        } else {
            this.form.find('.WEBFORMTYPE').val('');
        }
    }

    manageScroll() {
        let top = this.form.parents('.landing-form').offset().top + this.form.parents('.landing-form').outerHeight() - $('.simple-header').outerHeight();
        $('body').toggleClass('form-gone', $('html, body').scrollTop() > top);
        document.dispatchEvent(new CustomEvent('form-gone'));
    }

    hideTime() {
        this.form.find('#time-wrapper').hide();
        this.updateWebform();
    }
}

export default FormComponent;